export default __webpack_public_path__ + "static/media/justin.5617ec51.jpg";